import { render, staticRenderFns } from "./Editorials.vue?vue&type=template&id=2e89e9d6&"
import script from "./Editorials.vue?vue&type=script&lang=js&"
export * from "./Editorials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports